export default "__VITE_ASSET__Csdrb_iR__"